import { EntGovernment } from "../handBooks/government";


export class EntFinancialIndicators {
  alias: string | null = null;
  id: number | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  budgetTotal: number | null = null;
  budgetRepublican: number | null = null;
  budgetSpecialAccount: number | null = null;
  budgetDonorFunds: number | null = null;
  budgetOther: number | null = null;
  budgetOtherDescription: string | null = null;
  expensesTotal: number | null = null;
  expensesSalary: number | null = null;
  expensesRealEstateMaintenance: number | null = null;
  expensesMovableProperty: number | null = null;
  expensesOther: number | null = null;
  expensesOtherDescription: string | null = null;
  remainingBudget: number | null = null;
  government: EntGovernment | null = null;
  deleted: boolean | null = null;
  editedTime: any | null = null;
  createdTime: string | null = null;


}
